<template>
  <div class="row">
    <loader v-if="loading"></loader>
    <div v-else>
      <h1>Campos do Formulário do Passo "{{step.name}}"</h1>
      <hr>
      <router-link id="btn-add-field" :to="{name: 'StepFieldDetail', params: {stepId: $route.params.stepId, actionId: $route.params.actionId}}" type="button" class="btn btn-primary">
          <span class="glyphicon glyphicon-plus"></span> Adicionar Campo
      </router-link>
      <br><br>
      <loader v-if="updating"></loader>
      <div v-if="fields.length == 0" class="alert alert-info" id="msg-no-fields">
        O passo ainda não possui campos de preenchimento.
      </div> 
      <draggable v-model="fields" @end="checkMove" class="list-group" v-else>
          <div v-for="(f, index) in fields" class="list-group-item">
              <span>
                  <h4 class="list-group-item-heading">
                      <span v-if="f.type == 'text'" class="glyphicon glyphicon-text-size"></span>
                      <span v-if="f.type == 'number'" class="glyphicon glyphicon-plus"></span>
                      <span v-if="f.type == 'date'" class="glyphicon glyphicon-calendar"></span>
                      <span v-if="f.type == 'file'" class="glyphicon glyphicon-file"></span>
                      <span v-if="f.type == 'select'" class="glyphicon glyphicon-list"></span>
                      <span v-if="f.type == 'link'" class="glyphicon glyphicon-link"></span>
                      <span v-if="f.type == 'textarea'" class="glyphicon glyphicon-font"></span>
                      <span v-if="f.type == 'user'" class="glyphicon glyphicon-user"></span>
                      {{f.name}}
                      <span v-if="f.required" class="required">(Obrigatório)</span>
                      <span v-if="f.private" class="private">(Campo Privado)</span>
                      <span class="pull-right">
                        <router-link :to="{name: 'StepFieldDetail', params: {stepId: $route.params.stepId, actionId: $route.params.actionId, id: f.objectId}}" type="button" class="btn btn-xs btn-primary" title="Editar campo">
                          <span class="glyphicon glyphicon-edit"></span> Editar
                        </router-link>
                        <button class="btn btn-xs btn-danger" @click="remove(f)" title="Remover campo">
                          <span class="glyphicon glyphicon-remove"></span> Remover
                        </button>
                      </span>
                  </h4>
                  <p class="list-group-item-text">{{f.description }}</p>
              </span>
          </div>
      </draggable>
      <button type="button" class="btn btn-default" @click="cancel">Voltar</button>
    </div>
  </div>
</template>

<script>
import {
  Parse,
  miniToastr
} from '../Global'

import Loader from './util/Loader'
import draggable from 'vuedraggable'
import { handleParseError } from './util/ErrorHandling'

export default {
  components: {
    Loader,
    draggable
  },
  data () {
    return {
      loading: false,
      updating: false,
      fields: [],
      fieldsParse: [],
      step: {},
      title: null
    }
  },
  mounted () {
    this.getFieldsData()
  },
  methods: {
    getFieldsData () {
      let self = this
      self.loading = true
      let stepId = self.$route.params.stepId
      let actionId = self.$route.params.actionId
      let query = new Parse.Query('Step')
      query.get(stepId).then(result => {
        self.step = result.toJSON()
        let queryFields = new Parse.Query('StepField')
        queryFields.ascending('order')
        queryFields.equalTo('step', result)
        if (actionId) {
          let StepAction = Parse.Object.extend('StepAction')
          let action = new StepAction()
          action.id = actionId
          queryFields.equalTo('stepAction', action)
        } else {
          queryFields.doesNotExist('stepAction')
        }
        return queryFields.find()
      }).then(results => {
        self.fieldsParse = results
        self.fields = results.map(f => f.toJSON())
        self.loading = false
      }).fail(error => {
        self.loading = false
        handleParseError(self, error)
      })
    },
    cancel () {
      this.$router.go(-1)
    },
    remove (field) {
      if (confirm('Deseja realmente remover o campo?')) {
        let self = this
        let fieldParse = self.fieldsParse.find(f => f.id === field.objectId)
        fieldParse.destroy({
          success () {
            miniToastr.success('Excluído com sucesso.')
            self.getFieldsData()
          },
          error (obj) {
            miniToastr.error(obj.error)
          }
        })
      }
    },
    checkMove (evt) {
      if (evt.newIndex !== evt.oldIndex) {
        let self = this
        let updateList = []
        self.updating = true
        self.fields.forEach((field, index) => {
          let fieldParse = self.fieldsParse.find(f => f.id === field.objectId)
          fieldParse.set('order', index)
          updateList.push(fieldParse)
        })
        Parse.Object.saveAll(updateList).then(list => {
          self.fieldsParse = list
          self.updating = false
        }).fail(error => {
          self.updating = false
          handleParseError(self, error)
        })
      }
    }
  }
}
</script>

<style>
.required {
  font-size: 10px;
  color: #c71916;
}
.private {
  font-size: 10px;
  color: #bbbb04;
}
</style>



// WEBPACK FOOTER //
// StepFieldList.vue?72e8517c